module.exports = __webpack_public_path__ + "img/agentPay - Logo.8223dd91.svg";